import * as React from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Link} from "react-router-dom";

export default class FooterPage extends React.Component{
    render(){
        return(
            <MDBFooter className="font-small pt-4 mt-4 footer_container">
                <MDBContainer fluid className="text-center text-md-left">
                    <MDBRow>
                        <MDBCol md="4">
                            <ul>
                                <li key={"1"} className="list-unstyled">
                                    <h5 className="title">Kontakt</h5>
                                </li>
                                <li key={"12"} className="list-unstyled">
                                    <h6>RuS Mehele GmbH</h6>
                                </li>
                                <li key={"2"} className="list-unstyled">
                                    Radetzkystraße 132
                                </li>
                                <li key={"3"} className="list-unstyled">
                                    A- 6845 Hohenems
                                </li>
                                <li key={"4"} className="list-unstyled">
                                    Tel.: +43-5576-72397-0
                                </li>
                                <li key={"5"} className="list-unstyled">
                                    Mail: office@mehele.at
                                </li>

                            </ul>
                        </MDBCol>
                        <MDBCol md="4">
                            <ul>
                                <li key={"6"} className="list-unstyled">
                                    <h5 className="title">Links</h5>
                                </li>
                                <li key={"7"} className="list-unstyled">
                                    <Link className="link-unstyled" to={"/Öffnungszeiten"}>Öffnungszeiten</Link>
                                </li>
                                <li key={"8"} className="list-unstyled">
                                    <Link className="link-unstyled" to={"/Kontakt"}>Kontakt</Link>
                                </li>
                                <li key={"9"} className="list-unstyled">
                                    <Link className="link-unstyled" to={"/Neumaschinen"}>Neumaschinen</Link>
                                </li>
                                <li key={"10"} className="list-unstyled">
                                    <Link className="link-unstyled" to={"/Verkauf"}>Gebrauchte</Link>
                                </li>
                                <li key={"11"} className="list-unstyled">
                                    <Link className="link-unstyled" to={"/Impressum"}>Impressum</Link>
                                </li>

                            </ul>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </MDBFooter>
        );
    }
};
